import { Dialog } from "../../../surfaces/Dialog";

const Modal = ({ id, handleClose, children, open, ...props }) => {
  return (
    <Dialog
      id={`${id}-custom-modal`}
      onClose={handleClose}
      aria-labelledby="customized-modal"
      open={open || false}
      {...props}
    >
      {children}
    </Dialog>
  );
};

export default Modal;
